import MarkerSymbol from './MarkerSymbol';
import Point from '../geometry/Point';
import GeometryFactory from '../geometry/GeometryFactory';
import SymbolFactory from './SymbolFactory';

/**
 * 多图片点符号,支持显示多行多列图片,可以自定义图片之间的水平间距和垂直间距.
 */
export default class MultiImageMarkerSymbol extends MarkerSymbol {
    constructor(options) {
        super(options);

        this.width = 10;
        this.height = 10;
        this.hGap = 0;
        this.vGap = 0;
        this.urls = [];
        this.type = 'MultiImageMarkerSymbol';

        this.fromJson(options);
    }

    fromJson(json) {
        super.fromJson(json);

        this._setValue('width', json.width);
        this._setValue('height', json.height);
        this._setValue('hGap', json.hGap);
        this._setValue('vGap', json.vGap);
        this._setValue('urls', json.urls);
    }

    toJson() {
        const json = super.toJson();

        json.width = this.width;
        json.height = this.height;
        json.hGap = this.hGap;
        json.vGap = this.vGap;
        json.urls = this.urls;

        return json;
    }

    getImgUrls() {
        return this.urls;
    }

    draw(ctx, geometry) {
        if (!this.urls || this.urls.length === 0) {
            return;
        }

        super.draw(ctx, geometry);
    }

    /**
     * 重写父类方法,以多个图片绘制点符号.
     * @param {Object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @return {undefined}
     */
    _drawContent(ctx) {
        const geometries = this._getGeometries();

        const json = {
            type: 'ImageMarkerSymbol',
            width: this.width,
            height: this.height
        };
        const symbolFactory = SymbolFactory.getInstance();
        const symbol = symbolFactory.createSymbol(json);
        symbol.setResourceFactory(this._resourceFactory);
        symbol.resetTransform = false;

        for (let i = 0; i < this.urls.length; ++i) {
            for (let j = 0; j < this.urls[i].length; ++j) {
                const geometry = geometries[i][j];
                const url = this.urls[i][j];
                if (url) {
                    symbol.url = url;
                    symbol.draw(ctx, geometry);
                }
            }
        }
    }

    /**
     * 根据属性配置,计算每个图片的绘制点位.
     * @returns {Array}.
     */
    _getGeometries() {
        const info = this._getRowAndColumn();
        const actualHGap = this.hGap ? this.hGap : this.width;
        const actualVGap = this.vGap ? this.vGap : this.height;
        const totalWidth = this.width + actualHGap * (info.col - 1);
        const totalHeight = this.height + actualVGap * (info.row - 1);
        const startX = -totalWidth / 2;
        const startY = -totalHeight / 2;
        const geometries = [];
        for (let i = 0; i < info.row; ++i) {
            const y = startY + actualVGap * i + this.height / 2;
            const row = [];
            for (let j = 0; j < info.col; ++j) {
                const x = startX + actualHGap * j + this.width / 2;
                const geometry = new Point(x, y);
                row.push(geometry);
            }
            geometries.push(row);
        }

        return geometries;
    }

    /**
     * 计算图片的最大行数和列数
     * @returns {{row: Number, col: number}}.
     */
    _getRowAndColumn() {
        const row = this.urls.length;
        let col = 0;
        for (let i = 0; i < this.urls.length; ++i) {
            const temCol = this.urls[i].length;
            if (col < temCol) {
                col = temCol;
            }
        }

        return {
            row: row,
            col: col
        };
    }

    /**
     * 返回符号在局部坐标系下的bound
     * x方向为宽度，y方向为高度
     * @returns {Object} bound
     */
    getOriginBound() {
        const info = this._getRowAndColumn();
        const actualHGap = this.hGap ? this.hGap : this.width;
        const actualVGap = this.vGap ? this.vGap : this.height;
        const totalWidth = this.width + actualHGap * (info.col - 1);
        const totalHeight = this.height + actualVGap * (info.row - 1);
        const gf = GeometryFactory.getInstance();
        const bound = gf.createBound(null, totalWidth, totalHeight);

        return bound;
    }
}
